import React from 'react';
import axios from "../../../../containers/api";
import {Alert, Button, FormGroup, Label} from "reactstrap";
import {getkalas, showCatchError} from "../../../../helpers/Utils";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import {Table} from "../../../../components/table/Table";

class NotAllowedkalas extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            agentId: this.props && this.props.agentId,
            kalas: [],
            kala: null,
            AgentkalaLists: [],
            errors: []
        }
    }

    componentDidMount() {
        this.GetAgencyNotAllowedkalasForInstantBill();
        try {
            this.getkalasApi().then(r => console.log(r));
        } catch (err) {
            console.log(err);
        }
    }

    GetAgencyNotAllowedkalasForInstantBill = () => {
        this.props.showSpinner();
        axios.get('api/AgencyApi/GetAgencyNotAllowedkalasForInstantBill?agentId=' + this.state.agentId)
            .then((res) => {
                this.props.hideSpinner();
                this.setState({AgentkalaLists: res.data});
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };

    async getkalasApi() {
        try {
            await getkalas()
                .then((res) => this.setState({kalas: res}) );
        } catch (err) {
            this.props.showAlert(showCatchError(err), "error");
        }
    }

    validateInputData = () => {
        this.props.closeSweetAlert();
        let error = [];
        if (this.state.kala === null || this.state.kala === "") {
            error.push("لطفا نوع محموله را انتخاب کنید.");
        }

        this.setState({errors: error});
        if (error.length === 0) {
            this.AddkalaToNotAllowedkalasForInstantBill();
        } else {
            this.props.showAlert("لطفا تمامی اطلاعات درخواست شده را به درستی وارد کنید!", "error");
        }
    };

    AddkalaToNotAllowedkalasForInstantBill = () => {
        this.props.showSpinner();
        axios.get('api/AgencyApi/AddkalaToNotAllowedkalasForInstantBill?agentId=' + this.state.agentId + "&kalaId=" + this.state.kala.kalaID)
            .then((res) => {
                this.props.hideSpinner();
                if (res.status === 200) {
                    this.GetAgencyNotAllowedkalasForInstantBill();
                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };

    DeletekalaFromNotAllowedkalasForInstantBill = (kalaId) => {
        this.props.closeSweetAlert();
        this.props.showSpinner();
        axios.get('api/AgencyApi/DeletekalaFromNotAllowedkalasForInstantBill?agentId=' + this.state.agentId + "&kalaId=" + kalaId)
            .then((res) => {
                this.props.hideSpinner();
                if (res.status === 200) {
                    this.GetAgencyNotAllowedkalasForInstantBill();
                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };

    selectHandleChange = (event, value, name) => {
        this.setState({[name]: value });
    };

    render() {
        return (
            <div className="d-flex flex-column w-100">
                <div className="d-flex flex-md-row flex-column justify-content-center flex-wrap w-100 mt-5">
                    <FormGroup className="w-md-30 w-100 px-1">
                        <Label>نوع محموله</Label>
                        <Autocomplete
                            clearText={"حذف"}
                            closeText={"بستن"}
                            noOptionsText={"در حال دریافت اطلاعات.."}
                            openText={"باز کردن"}
                            className="react-select__control"
                            id="kala"
                            options={this.state.kalas}
                            getOptionLabel={(option) => option.kalaName}
                            value={this.state.kala}
                            onChange={(e, v) => this.selectHandleChange(e, v, "kala")}
                            renderInput={(params) => (<TextField{...params} variant="standard"/>)}
                        />
                    </FormGroup>
                </div>

                {this.state.errors.length === 0 ?
                    null
                    :
                    <div>
                        {(this.state.errors.map((error, i) => {
                            return (
                                <Alert color="danger" key={i}>{error}</Alert>
                            )
                        }))}
                    </div>
                }

                <div className="d-flex flex-md-row flex-column justify-content-center align-items-end flex-wrap w-100 mt-5">
                    <FormGroup className="text-center">
                        <Button color="primary" className="btn-lg mx-2"
                                onClick={() => this.props.showSweetAlert("آیا از صحت اطلاعات وارد شده اطمینان دارید؟", "", "warning", this.validateInputData)}>
                            ثبت
                        </Button>
                    </FormGroup>
                </div>

                <Table
                    tableHeaders={[
                        "نوع محموله",
                        "حذف",
                    ]}

                    tableRow={this.state.AgentkalaLists}

                    tableData={[
                        item => {
                            return item.kala.kalaName;
                        },
                        item => {
                            return (
                                <Button outline color="danger" size="sm"
                                        onClick={() => this.props.showSweetAlert("آیا از حذف اطلاعات اطمینان دارید؟", "", "danger", () => this.DeletekalaFromNotAllowedkalasForInstantBill(item.kala.kalaID))}>
                                    حذف
                                </Button>
                            )
                        }
                    ]}
                />
            </div>
        );
    }
}

export default NotAllowedkalas;